import { render, staticRenderFns } from "./CustomersWithoutManageAccess.vue?vue&type=template&id=e0f237d0"
import script from "./CustomersWithoutManageAccess.vue?vue&type=script&lang=js"
export * from "./CustomersWithoutManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports